export function StringFormat(template: string, ...args: any[]): string {
    return template.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != 'undefined'
            ? args[number]
            : match
            ;
    });
};

// Joins names with commas and a trailing "and" (e.g. "A, B, and C"; "A and B"; "A").
export function FormatAndedStringList(systems: string[]): string {
    if (systems.length <= 1) {
        return systems[0] || '';
    }
    if (systems.length === 2) {
        return `${systems[0]} and ${systems[1]}`;
    }
    return `${systems.slice(0, -1).join(', ')}, and ${systems[systems.length - 1]}`;
};

